import * as React from 'react';
import {Breadcrumb, Grid, Input, Responsive} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
  ColumnSelectableComponentProps,
  ColumnSortableComponentProps,
  FilterObjectComponentProps,
  InfinityScrollComponentProps,
  ViewSettingsComponentProps,
  withColumnSelection,
  withColumnSort,
  withFilterObject,
  withInfinityScrollHandlers,
  withPrintAndExport,
  withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import {formatCurrency} from '../../utils/numbers';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import Moment from 'react-moment';
import moment from 'moment';
import AuctionServiceInstance from "../../services/AuctionService";
import {DataList} from "../../components/DataTable/DataList";
import {SortSelectionButton} from "../../components/DataTable/SortModal";
import {ViewLoadingSpinner} from "../../components/ViewLoadingSpinner";
import {TranslationFunction} from "i18next";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);


const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'data.datum',
        labelTranslationKey: 'AuctionDetails.Date',
        required: true,
        cellRender: v => <Moment format={t("Common.DateFormat")}>{v}</Moment>,
        printExportRender: v => moment(v).format(t("Common.DateFormat"))
    }, {
        fieldName: 'data.gesamtAnzahl',
        labelTranslationKey: 'AuctionDetails.Count',
        required: false
    },
    {
        fieldName: 'data.preisNiedrig',
        labelTranslationKey: 'AuctionDetails.PriceMin',
        required: false,
        cellRender: v => formatCurrency(v),
        printExportRender: v => formatCurrency(v)
    },
    {
        fieldName: 'data.preisDurchschnitt',
        labelTranslationKey: 'AuctionDetails.PriceAverage',
        required: false,
        cellRender: v => formatCurrency(v),
        printExportRender: v => formatCurrency(v)
    },
    {
        fieldName: 'data.preisHoechst',
        labelTranslationKey: 'AuctionDetails.PriceMax',
        required: false,
        cellRender: v => formatCurrency(v),
        printExportRender: v => formatCurrency(v)
    }

];


// TODO use router props in exported component instead of relying on ArticleStatistics to set this values during render
let articleID: String = "";
let articleDesc: String = "";
let articleLength: String = "";


const getScrollParent = () => ContentContainer.instance.componentRef.current;

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const ArticleStatistics = (props: RouteComponentProps<any> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {

    articleID = props.match.params.articleID;
    articleLength = props.match.params.articleLength;

    if (props.data && props.data.length > 0)
        articleDesc = props.data[0].data.beschreibung;

    if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }
  return (
      <>
        <AnalyticsTracking page="auctions/article" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>

             <h3><Breadcrumb icon="right angle" sections={[
                    {
                        key: '1',
                        as: NavLink,
                        to:  "/auctions/",
                        content: `${t ("Route.Auctions")}`,
                    },
                    {
                        key: '2',
                        content: `${t("Auctions.Article")}: ${articleID}; ${articleDesc}; ${t("Auctions.Length")}: ${articleLength}`,
                        active: true},
                  ]} /></h3>

            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
            <Grid columns={3} className={"HeadingGrid"} stackable={true}
                  style={{marginBottom: '1em'}}>
              <Grid.Column width={8}>
                <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                       value={props.filterObject.filter} onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
              </Grid.Column>
              <Responsive maxWidth={960} as={Grid.Column} width={3}>
                <SortSelectionButton
                  fluid={true}
                  availableColumns={COLUMNS}
                  currentSortColumn={props.sortColumn}
                  currentDirection={props.sortDirection}
                  onSave={props.handleSortUpdate}/>
              </Responsive>
              <Responsive minWidth={961} as={Grid.Column} width={3}>
                <ColumnSelectionButton
                  fluid
                  availableColumns={COLUMNS}
                  selectedColumns={props.selectedColumns}
                  onSave={props.updateSelectedColumns}/>
              </Responsive>
              <ViewLoadingSpinner active={props.loading} />
            </Grid>
          </div>
        </div>


        <div className={"ui container responsivewrapper"}>
          <Responsive minWidth={961}>
            <DataTable
                columns={COLUMNS}
                data={props.data}
                page={props.page}
                totalPages={props.totalPages}
                sortDirection={props.sortDirection}
                sortColumn={props.sortColumn}
                selectedColumns={props.selectedColumns}
                getScrollParent={getScrollParent}
                loadMore={props.loadMore}
                handleSortChange={props.handleSortChange}
                loading={props.loading}
                filter={props.filterObject}
            />
          </Responsive>
          <Responsive maxWidth={960}>
            <DataList data={props.data}
                      page={props.page}
                      totalPages={props.totalPages}
                      getScrollParent={getScrollParent}
                      loadMore={props.loadMore}
                      columns={COLUMNS}
                      renderItem={renderMobileListItems}
            />
          </Responsive>
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const renderMobileListItems = (row: any, t: TranslationFunction) => {
  return <>
    <div>
      <strong><Moment format={t("Common.DateFormat")}>{row.data.datum}</Moment></strong>
    </div>
    <div style={{textAlign: 'right', flexGrow: 1}}>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>{t('Auctions.Count_Short')} {row.data.gesamtAnzahl}&nbsp;</div>
        <div style={{textAlign: 'right'}}> &#8960; {formatCurrency(row.data.preisDurchschnitt)} €</div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>▼ {formatCurrency(row.data.preisNiedrig)} €</div>
        <div style={{textAlign: 'right'}}>▲ {formatCurrency(row.data.preisHoechst)} €</div>
      </div>
    </div>
  </>;
};

const dataService = {
  loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
    return AuctionServiceInstance.getAllByArcticle(articleID, articleLength , filter.filter ? filter.filter : "", sortColumn, sortOrder, page, 100);
  }
};

const ArticleStatisticsWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(ArticleStatistics)))))));

export default () => (
    <ArticleStatisticsWrapped
        viewName="article_statistics"
        dataService={dataService}
        defaultSortDirection="DESC"
        defaultSortColumn="data.datum"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.Auctions")}`]}
    />
);

